import React from 'react';
import { Location } from 'react-router-dom';
import 'react-router-dom';

import { InitContext, InitCtx } from '../context/InitProvider';

import auth from '../Auth/Auth';
import { PATHS } from './paths';
import { StringParam, useQueryParam } from 'use-query-params';
import { getIstaQueryParams } from '../Auth/utils';

type Props = {
  location: Location;
};

const Authenticate = ({ location }: Props) => {
  const { initializing, setAuthSuccess } = React.useContext<InitCtx>(InitContext);
  const [t] = useQueryParam('t', StringParam);

  React.useEffect(() => {
    if (location.pathname === PATHS.AUTH.CALLBACK) {
      return;
    }

    if (auth.isAuthenticated()) {
      if (initializing) setAuthSuccess();
      return;
    }

    // Cleanup cancels a restore that is still in flight, so deps changes never double-login.
    let cancelled = false;
    auth
      .restoreSession()
      .catch(() => false)
      .then((restored) => {
        if (cancelled) return;
        if (restored) {
          if (initializing) setAuthSuccess();
          return;
        }
        auth.login({
          signup: location.pathname === PATHS.AUTH.SIGN_UP,
          // ISTA enterprise flow: a special query param makes ui-auth show the ista login button
          customQueryParams: getIstaQueryParams(t),
        });
      });
    return () => {
      cancelled = true;
    };
  }, [location, initializing, setAuthSuccess]);
  return null;
};

export default Authenticate;
